var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSlideShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#434343;}\n\t.st1{fill:#434343;stroke:#303030;stroke-width:0.75;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.9,186.5l-30.8,100.6h-169l28.6-100.6H381.9 M391.4,165.6H205.5c-6.2,0-11.7,4.1-13.5,10.2l-37.7,132.3 h201.9c6.1,0,11.6-4,13.4-9.9l35.1-114.5C407.5,174.7,400.8,165.6,391.4,165.6L391.4,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.1,330l35.9-126h-7.8c-6.2,0-11.7,4.1-13.5,10.2l-32.6,114.5c-2.5,8.9,4.2,17.8,13.5,17.8H304 c6.1,0,11.6-4,13.4-9.9l2-6.6H125.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,6C117.9,6,6,117.9,6,256s111.9,250,250,250s250-111.9,250-250S394.1,6,256,6z M256,492.5 C125.4,492.5,19.5,386.6,19.5,256S125.4,19.5,256,19.5S492.5,125.4,492.5,256S386.6,492.5,256,492.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlideShow);
export default __webpack_public_path__ + "static/media/icon-slide-show.65f34d7936c742c2203fbcee8f6f8406.svg";
export { ForwardRef as ReactComponent };